import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import ApiClient from "#/redux/api/ApiClient";
import { handleLoadingAndErrorState } from "#/redux/util/reduxUtils.js";

const baseUrl = "/api/sif/uporabnostSemena";

export const getSeedUsabilityTypes = createAsyncThunk(
  "seedUsability/getAll",
  async ({ filter }, { rejectWithValue }) => {
    // eslint-disable-next-line no-console
    console.warn("Deprecated, migrate to LookupTable hooks and components");

    try {
      const response = await ApiClient.get(
        `${baseUrl}/page`,
        null,
        { page: 0, size: 1000 },
        filter
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const thunks = [getSeedUsabilityTypes];

const seedUsabilitySlice = createSlice({
  name: "seedUsability",
  initialState: {
    list: [],
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getSeedUsabilityTypes.fulfilled, (state, action) => {
      state.list = action.payload?.content || [];
    });

    handleLoadingAndErrorState(builder, thunks);
  },
});

export default seedUsabilitySlice.reducer;
